import { ITrackingDB } from 'type/tracking';

const BRACKET_GROUP_REGEX = /\[([^\[\]]+)\]/;
export const NO_GROUP = '그룹 없음';
export const ALL_GROUP = '전체';

/**
 * 트래킹 제목에서 그룹명을 추출
 * 첫 번째 유효한 [내용] 패턴, 없으면 '그룹 없음' 반환
 */
export const extractGroupName = (title: string): string => {
	const bracketMatch = title.match(BRACKET_GROUP_REGEX);
	const bracketGroup = bracketMatch?.[1]?.trim();
	if (bracketGroup) return bracketGroup;

	return NO_GROUP;
};

/**
 * 트래킹 리스트에서 고유 그룹 목록을 추출
 * - 반환: ['전체', ...그룹명들, '그룹 없음']
 * - '그룹 없음' 항목이 없으면 '그룹 없음' 칩 미포함
 */
export const extractGroupList = (items: ITrackingDB[]): string[] => {
	const groupSet = new Set<string>();
	items.forEach((item) => groupSet.add(extractGroupName(item.name)));

	const groups = Array.from(groupSet);
	const sorted = groups.filter((g) => g !== NO_GROUP);
	if (groups.includes(NO_GROUP)) sorted.push(NO_GROUP);

	return [ALL_GROUP, ...sorted];
};

/**
 * 선택된 그룹 기준으로 트래킹 리스트 필터링
 */
export const filterByGroup = (
	items: ITrackingDB[],
	selectedGroup: string,
): ITrackingDB[] => {
	if (selectedGroup === ALL_GROUP) return items;
	return items.filter((item) => extractGroupName(item.name) === selectedGroup);
};
